import React from 'react';
import { ArrowRightIcon, ArrowDownIcon, CheckIcon } from 'lucide-react';
import { scatteredApps } from '../../data/crm';
const tilts = ['-rotate-6', 'rotate-3', '-rotate-2', 'rotate-6', '-rotate-3', 'rotate-2'];
const offsets = ['mt-0', 'mt-8', 'mt-2', 'mt-6', 'mt-0', 'mt-4'];
export function ReplaceApps() {
  return <section className="bg-gray-50 px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-288" data-mp="a15oh7lifhog">
      <div className="mx-auto max-w-7xl" data-id="element-289" data-mp="3ri6srakqeblc">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-brand-black sm:text-4xl lg:text-5xl" data-id="element-290" data-mp="3rh5fczg8td0g">
          Replace the pile of apps
        </h2>

        <div className="mt-16 grid items-center gap-10 lg:grid-cols-[1fr_auto_1fr] lg:gap-12" aria-hidden="true" data-id="element-291" data-mp="3iitk2k4flr1o">
          <div className="grid grid-cols-3 gap-4 sm:gap-6" data-id="element-292" data-mp="3nhwpw6s8k1ap">
            {scatteredApps.map((app, i) => <div key={app.label} className={`flex flex-col items-center gap-2 rounded-xl border border-dashed border-gray-300 bg-white p-4 text-center ${tilts[i]} ${offsets[i]}`} data-id="element-293" data-mp="38ke339z4by5w" data-mpi={i}>
                <app.icon className="h-6 w-6 text-brand-gray" strokeWidth={1.5} data-id="element-294" data-mp="wx2roi7u1fs1" />
                <span className="text-xs font-semibold text-brand-gray" data-id="element-295" data-mp="rvwykja9fqhz">{app.label}</span>
              </div>)}
          </div>

          <div className="flex justify-center" data-id="element-296" data-mp="11um5xi4j5sjz">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-red text-white" data-id="element-297" data-mp="11uugh3d6kls0">
              <ArrowRightIcon className="hidden h-6 w-6 lg:block" data-id="element-298" data-mp="e505ysgc39ax" />
              <ArrowDownIcon className="h-6 w-6 lg:hidden" data-id="element-299" data-mp="96q9meivi2nq" />
            </span>
          </div>

          <div data-id="element-300" data-mp="my3rlo14usgn">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-xl" data-id="element-301" data-mp="mxvbln9pr718">
            <div className="flex items-center justify-between border-b border-gray-100 pb-4" data-id="element-302" data-mp="i5alavq0nc2g">
              <span className="text-lg font-extrabold text-brand-black" data-id="element-303" data-mp="3ql3sul2ddd7d">
                1Dash<span className="text-brand-red" data-id="element-304" data-mp="3ml3e0zbcyzzs">.Pro</span>
              </span>
              <span className="rounded-full bg-brand-tint px-3 py-1 text-xs font-bold text-brand-red" data-id="element-305" data-mp="1pjxkor5b39p1">All in one</span>
            </div>
            <ul className="mt-4 grid grid-cols-2 gap-3" data-id="element-306" data-mp="1uhz1t6j68yxv">
              {['Scheduling', 'Texting', 'Email', 'Reviews', 'Invoicing', 'Pipeline'].map(item => <li key={item} className="flex items-center gap-2 rounded-md bg-brand-light px-3 py-2.5 text-sm font-semibold text-brand-black" data-id="element-307" data-mp="248u0599ozozo">
                  <CheckIcon className="h-4 w-4 text-brand-red" strokeWidth={3} data-id="element-308" data-mp="16md5ycw99ri5" />
                  {item}
                </li>)}
            </ul>
          </div>
          <p className="mt-3 text-center text-xs font-medium text-brand-gray" data-id="element-309" data-mp="1gipwx30f1r97">Powered by HighLevel</p>
          </div>
        </div>

        <p className="mt-16 text-center text-xl font-bold text-brand-black sm:text-2xl" data-id="element-310" data-mp="1lj3z44fc66zb">
          One login. One bill. One place your whole team works.
        </p>
      </div>
    </section>;
}